import React,{useRef,useEffect,useCallback}from'react';import styled from'styled-components';import PropTypes from'prop-types';import {BREAKPOINTS,H1}from'@manulife/mux';import {useIntl}from'react-intl';import ScreenReaderOnlyComponent from'../ScreenReaderOnlyComponent/ScreenReaderOnlyComponent.js';import Header from'./Header.js';import Footer from'./Footer.js';import SideNav from'./SideNav.js';import {getFilteredRealms,HEADER_REALM_KEYS}from'../../utils/realmUtils.js';import useRealm from'../../hooks/useRealm.js';import {sendAdobeAnalyticsClick}from'../Analytics/AdobeAnalytics.js';var HeaderWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "Layout__HeaderWrapper",
  componentId: "sc-3uqwjo-0"
})(["header{position:fixed;width:100%;}"]);
var SideNavWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "Layout__SideNavWrapper",
  componentId: "sc-3uqwjo-1"
})(["@media (min-width:", "px){& > nav{position:fixed;top:40px;}}"], BREAKPOINTS.DESKTOP_SM);
var Container = /*#__PURE__*/styled.div.withConfig({
  displayName: "Layout__Container",
  componentId: "sc-3uqwjo-2"
})(["display:flex;flex-direction:column;position:relative;margin:0;top:60px;min-height:calc(100vh - 40px);@media (min-width:", "px){margin:0 0 0 80px;top:40px;}"], BREAKPOINTS.DESKTOP_SM);
var ContentWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "Layout__ContentWrapper",
  componentId: "sc-3uqwjo-3"
})(["display:flex;flex-direction:column;flex-grow:1;height:100%;min-height:calc(100vh - 207px);padding-bottom:40px;"]);
var FooterWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "Layout__FooterWrapper",
  componentId: "sc-3uqwjo-4"
})([""]);
var Layout = function Layout(_ref) {
  var isEmbedded = _ref.isEmbedded,
    onLogout = _ref.onLogout,
    onLanguageToggle = _ref.onLanguageToggle,
    children = _ref.children,
    showLangToggle = _ref.showLangToggle,
    showContactUs = _ref.showContactUs,
    showRealmToggle = _ref.showRealmToggle,
    showManageId = _ref.showManageId,
    absoluteCiamDomain = _ref.absoluteCiamDomain,
    heading = _ref.heading;
  var realm = useRealm();
  var contentRef = useRef();
  var footerRef = useRef();
  var headingRef = useRef();
  var intl = useIntl();
  useEffect(function () {
    if (heading) {
      var _headingRef$current;
      (_headingRef$current = headingRef.current) === null || _headingRef$current === void 0 ? void 0 : _headingRef$current.focus();
    }
  }, [heading, headingRef]);
  var handleLanguageChange = useCallback(function () {
    onLanguageToggle();
    sendAdobeAnalyticsClick({
      click: {
        linkName: intl.formatMessage({
          id: 'shared.language.changed'
        })
      }
    });
  }, [intl, onLanguageToggle]);
  var handleOnLogout = useCallback(function () {
    onLogout();
    sendAdobeAnalyticsClick({
      click: {
        linkName: intl.formatMessage({
          id: 'shared.layout.utilityBar.signOut'
        })
      }
    });
  }, [intl, onLogout]);
  if (isEmbedded) {
    return children;
  }
  var isShowRealmToggle = showRealmToggle && Object.values(getFilteredRealms(HEADER_REALM_KEYS)).includes(realm);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(HeaderWrapper, null, heading && /*#__PURE__*/React.createElement(ScreenReaderOnlyComponent, {
    focusElementRef: headingRef,
    tabIndex: "-1",
    "data-testid": "screen-reader-only-heading"
  }, /*#__PURE__*/React.createElement(H1, null, heading)), /*#__PURE__*/React.createElement(Header, {
    onLanguageToggle: handleLanguageChange,
    onLogout: handleOnLogout,
    absoluteCiamDomain: absoluteCiamDomain,
    mainContentRef: contentRef,
    footerRef: footerRef,
    showLangToggle: showLangToggle,
    showContactUs: showContactUs,
    showRealmToggle: isShowRealmToggle,
    showManageId: showManageId
  })), /*#__PURE__*/React.createElement(SideNavWrapper, null, /*#__PURE__*/React.createElement(SideNav, {
    onLanguageToggle: handleLanguageChange,
    onLogout: handleOnLogout,
    absoluteCiamDomain: absoluteCiamDomain,
    showLangToggle: showLangToggle,
    showContactUs: showContactUs,
    showRealmToggle: isShowRealmToggle,
    showManageId: showManageId
  })), /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(ContentWrapper, {
    ref: contentRef,
    tabIndex: "-1"
  }, children), /*#__PURE__*/React.createElement(FooterWrapper, {
    ref: footerRef,
    tabIndex: "-1"
  }, /*#__PURE__*/React.createElement(Footer, null))));
};
process.env.NODE_ENV !== "production" ? Layout.propTypes = {
  children: PropTypes.node,
  isEmbedded: PropTypes.bool,
  onLogout: PropTypes.func.isRequired,
  onLanguageToggle: PropTypes.func.isRequired,
  showLangToggle: PropTypes.bool,
  showContactUs: PropTypes.bool,
  showRealmToggle: PropTypes.bool,
  showManageId: PropTypes.bool,
  absoluteCiamDomain: PropTypes.string,
  heading: PropTypes.string
} : void 0;
Layout.defaultProps = {
  children: null,
  isEmbedded: false,
  showLangToggle: true,
  showContactUs: true,
  showRealmToggle: true,
  showManageId: true,
  absoluteCiamDomain: '',
  heading: null
};
var Layout$1 = Layout;export{Layout$1 as default};